import { FC } from 'react';
import { FrequencyOptimizationInsightsMainContent } from 'modules/intelligentInsights/frequencyOptimization/components/FrequencyOptimizationInsightsMainContent';

export const FrequencyOptimizationInsightsIndexPage: FC = () => {
  return <FrequencyOptimizationInsightsMainContent />;
};
